/**
 * Se definen los roles de la plataforma
 */
export const roles = {
    Admin: "Administrador",
    Operador: "Operador",
    Barista: "Barista",
    Auditor: "Auditor",
    Asesor: "Asesor",
    AdminCatalogos: "Administrador de catalogos",
    UsuarioBarra: "Usuario Barra", // Rol TEMPORAL porque querian restringir las vistas de ciclicos a ciertas barras
}